import React, { useMemo, useState } from "react";
import BuyButton from "./BuyButton";
import { add as addToCartService } from "../Services/Cart.service";
import { receive, toggle } from "../Actions/Cart.action";
import { useDispatch } from "react-redux";
import { StockStatus } from "../constants";
import { translate, translateFormat } from "../Services/translation";

const removeColonAndNumber = (status) => {
  const regex = /:([0-9]+)$/;

  const match = status.match(regex);

  let resultString;
  if (match) {
    resultString = status.replace(regex, "");
  } else {
    resultString = status;
  }

  return resultString;
};

const AddonCardStockStatus = ({ status, text }) => {
  const formattedStatus = useMemo(() => removeColonAndNumber(status), [status]);

  const getIcon = (formattedStatus) => {
    switch (formattedStatus) {
      case StockStatus.Green:
        return (
          <div className="stock-status__icon stock-status__icon--green"></div>
        );
      case StockStatus.RedLow:
      case StockStatus.RedMedium:
        return (
          <div className="stock-status__icon stock-status__icon--lime"></div>
        );
      case StockStatus.RedHigh:
      case StockStatus.RedHighest:
      case StockStatus.Yellow:
        return (
          <div className="stock-status__icon stock-status__icon--yellow"></div>
        );
      default:
        break;
    }
  };

  return (
    <div className="stock-status__wrapper">
      {getIcon(removeColonAndNumber(formattedStatus))}
      <span className="stock-status__text">
        {translate("stockstatus.stock-title-" + formattedStatus.toLowerCase())}:{" "}
        {text}
      </span>
    </div>
  );
};

const AddonCard = ({ variant, label }) => {
  // Products sold in packs (2-pack, 4-pack, ...) start at one pack and step a whole pack at a time.
  const packSize = Math.max(1, variant.packSize || 1);
  const [quantity, setQuantity] = useState(packSize);
  const dispatch = useDispatch();

  const addToCart = async () => {
    const cart = await addToCartService({
      articleNumber: variant.sku,
      quantity: quantity,
      price: variant.price,
    });

    dispatch(receive(cart));
    dispatch(toggle());
  };

  return (
    <div className="product-detail__addon-card" key={variant.sku}>
      {variant.defaultImageUrl && (
        <img
          src={variant.defaultImageUrl}
          className="product-detail__addon-card-image"
        />
      )}
      <div className="product-detail__addon-card-text-wrapper">
        {variant.brand && (
          <div className="product-detail__addon-card-brand">
            {variant.brand}
          </div>
        )}
        {variant.name && (
          <div className="product-detail__addon-card-name">{variant.name}</div>
        )}
        {packSize > 1 && (
          <div className="product-detail__addon-card-pack-size">
            {translateFormat("product.soldinpack", packSize)}
          </div>
        )}
        <div className="product-detail__addon-card-price">
          {variant.formattedCampaignPrice ? (
            <>
              <span className="product__campaign-price">
                {variant.formattedCampaignPrice}
              </span>
              <span className="product__old-price">
                {variant.formattedPrice}
              </span>
            </>
          ) : (
            <span className="price">{variant.formattedPrice}</span>
          )}
        </div>
        <AddonCardStockStatus
          status={variant.deliveryStatus}
          text={variant.deliveryText}
        />
      </div>
      <div className="product-detail__addon-card-cta-wrapper">
        <div className="product-detail__quantity-wrapper">
          <div
            className="product-detail__quantity-decrease"
            onClick={() => {
              quantity - packSize >= packSize && setQuantity(quantity - packSize);
            }}
          >
            -
          </div>
          <input
            id={variant.sku}
            type="number"
            className="form__input product-detail__quantity-input"
            value={quantity}
            min={packSize}
            step={packSize}
          />
          <div
            className="product-detail__quantity-increase"
            onClick={() => {
              quantity + packSize <= 999 && setQuantity(quantity + packSize);
            }}
          >
            +
          </div>
        </div>
        <BuyButton
          label={label}
          articleNumber={variant.sku}
          quantityFieldId={variant.sku}
          price={variant.price}
          cssClass={"button buy-button product-detail__buy-button"}
          onClick={() => addToCart()}
        />
      </div>
    </div>
  );
};

const AddonList = ({ addon, label }) => {
  const [amountToShow, setAmountToShow] = useState(3);

  return (
    <div className="product-detail__addon" key={addon.name}>
      <div className="product-detail__addon-header">
        {addon.name && (
          <h2 className="product-detail__addon-title">{addon.name}</h2>
        )}
        {addon.description && (
          <div className="product-detail__addon-subtitle">
            {" - " + addon.description}
          </div>
        )}
      </div>
      {addon.configVariants &&
        !!addon.configVariants.length &&
        addon.configVariants
          .slice(0, amountToShow)
          .filter((addon) => !addon.soldOut)
          .map((variant) => (
            <AddonCard variant={variant} key={variant.sku} label={label} />
          ))}
      {addon.configVariants &&
        addon.configVariants.length > 3 &&
        (amountToShow != addon.configVariants.length ? (
          <div
            className="product-detail__show-more"
            onClick={() => setAmountToShow(addon.configVariants.length)}
          >
            {translate("product.show-more")}
          </div>
        ) : (
          <div
            className="product-detail__show-more"
            onClick={() => setAmountToShow(3)}
          >
            {translate("product.show-less")}
          </div>
        ))}
    </div>
  );
};

const AddonProduct = ({ addons, label }) => {
  return (
    <div className="product-detail__buy-more-wrapper">
      {addons &&
        !!addons.length &&
        addons.map((addon, idx) => (
          <AddonList addon={addon} label={label} key={idx} />
        ))}
    </div>
  );
};

export default AddonProduct;
